/** @jsx jsx */
/**
 *
 * FreshPets Instagram Grid Item
 *
 */
import { Img } from 'react-image'
import { Card, jsx } from 'theme-ui'
import LazyPlaceholder from '../../components/lazy-placeholder/lazy-placeholder'

const InstagramGridItem = ({ post }) => (
    <Card>
        <Img
            src={post.media_url}
            sx={{
                maxWidth: '100%',
                borderRadius: 2,
                mb: 3
            }}
            alt={post.caption || 'Fresh Pets Instagram post'}
            decode={true}
            loader={<LazyPlaceholder />}
        />
    </Card>
)

export default InstagramGridItem
